var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboardClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/clipboard-close"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clipboard-close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.6667 29.6267L18.4067 22.3667",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.5933 22.4399L18.3333 29.6999",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.3334 11.0001H25.6667C29.3334 11.0001 29.3334 9.16675 29.3334 7.33341C29.3334 3.66675 27.5001 3.66675 25.6667 3.66675H18.3334C16.5001 3.66675 14.6667 3.66675 14.6667 7.33341C14.6667 11.0001 16.5001 11.0001 18.3334 11.0001Z",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M29.3333 7.37012C35.4383 7.70012 38.5 9.95512 38.5 18.3335V29.3335C38.5 36.6668 36.6667 40.3335 27.5 40.3335H16.5C7.33333 40.3335 5.5 36.6668 5.5 29.3335V18.3335C5.5 9.97345 8.56167 7.70012 14.6667 7.37012",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardClose);
export default __webpack_public_path__ + "static/media/clipboard-close.dec11b208a58c80310a50657b51bc3fd.svg";
export { ForwardRef as ReactComponent };